import { AppShell, Loader } from '@mantine/core';
import { useUnit } from 'effector-react';
import { cashdeskPageModel } from '../../model';
import { CashdeskPageForm } from '../cashdesk-page-form';
import { CashdeskPageHeading } from '../cashdesk-page-heading';
import cls from './cashdesk-page.module.scss';

export const CashdeskPage = () => {
	const loading = useUnit(cashdeskPageModel.$pending);

	return (
		<AppShell.Main className={cls.cashdeskPage}>
			{loading ? (
				<Loader />
			) : (
				<>
					<CashdeskPageHeading />
					<CashdeskPageForm />
				</>
			)}
		</AppShell.Main>
	);
};
